import type { ExternalTableSchema } from '@packages/table-builder';

/** Replaces legacy enrollment list hook — runtime IDs substituted in endpoint below */
export function buildEsppPurchaseDetailTable(
  offeringPeriodId: string,
  purchasePeriodId: string,
): ExternalTableSchema {
  return {
    metadata: {
      title: 'Select Items for Purchase',
      entity: 'Enrollment',
    },

    dataSource: {
      endpoint:
        '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/enrollment'
          .replace('{offeringPeriodId}', offeringPeriodId)
          .replace('{purchasePeriodId}', purchasePeriodId),
      method: 'GET',
      rowIdField: 'employeeId',
      responseMapping: {
        items: 'items',
        totalCount: 'totalCount',
      },
      requestParams: {
        // Service (EsppEnrollmentService) uses Filter — search enabled, pass text to Filter param
        Filter: 'table.searchText',
        MaxResultCount: 'table.pageSize',
        SkipCount: 'table.pageOffset',
        Sorting: 'table.sorting',
      },
      staticQueryParams: {
        EnrollmentStatus: ['Enrolled'],
      },
    },

    columns: [
      {
        field: 'firstName',
        header: 'Participant Details',
        type: 'couple',
        width: 200,
        sortable: true,
        couple: {
          titleField: 'firstName',
          subtitleField: 'emailAddress',
        },
      },
      {
        field: 'eligibilityStatus',
        header: 'Eligibility Status',
        type: 'badge',
        width: 220,
        sortable: true,
        align: 'center',
        badge: {
          statusMap: {
            Eligible: 'success',
            Ineligible: 'error',
            Pending: 'warning',
          },
          defaultVariant: 'info',
        },
      },
      {
        field: 'enrollmentStatus',
        header: 'Enrollment Status',
        type: 'badge',
        width: 220,
        sortable: true,
        align: 'center',
        badge: {
          statusMap: {
            Enrolled: 'info',
            Withdrawn: 'error',
            Pending: 'warning',
          },
          defaultVariant: 'info',
        },
      },
      {
        field: 'contributionAmountPerPay',
        header: 'Contribution',
        type: 'number',
        width: 80,
        align: 'center',
        editable: { type: 'number' },
      },
    ],

    actions: {
      toolbar: {
        primary: {
          id: 'ADD_TO_PURCHASE_ESPP',
          label: 'Add to Purchase',
          icon: 'add_circle_outline',
        },
      },
    },

    features: {
      search: { enabled: true },
      selection: { keyField: 'employeeId' },
      pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    },
  };
}
